export default {
    bind(el, binding) {
        let value = el.innerText;
        const parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        el.innerText = parts.join(".");
    }
};